<app-header></app-header>
<ng-template #updateBillingInformationModal>
  <mat-card-header class="m-b-20px subheading-2 table-header-color px-0 p-2">
    <mat-card-title mat-dialog-title [style.font-family]="'var(--vex-font)'">
        <span class="subheading-2 text-xl text-white text-bold">
          <mat-icon svgIcon="mat:ballot" class="text-white pt-2"></mat-icon>
          <span>Update Billing Information</span>
        </span>
      <i class="fa fa-window-close mt-1 sm:mt-0 text-white text-xl float-right text-bold cursor-pointer"
         (click)="dialog.closeAll()"></i>
    </mat-card-title>
  </mat-card-header>
  <div mat-dialog-content>
    <form [formGroup]="checkoutForm">
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Organisation Name</mat-label>
          <input matInput placeholder="Enter Your Organisation Name" formControlName="organisation_name"
                 [disabled]="true">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('organisation_name').hasError('required')">Organisation
            name
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Enter your name" formControlName="name">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('name').hasError('required')">Name
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Enter your email" formControlName="email">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('email').hasError('required')">Email
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Contact</mat-label>
          <input matInput placeholder="Enter your contact" formControlName="contact">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('contact').hasError('required')">Contact
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Username</mat-label>
          <input matInput placeholder="Enter username" formControlName="username">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('username').hasError('required')">Username
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'"
                        [hideRequiredMarker]="true">
          <mat-label>GSTIN</mat-label>
          <input matInput placeholder="Enter organisation GSTIN" formControlName="gst_number">
        </mat-form-field>
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'"
                        [hideRequiredMarker]="true">
          <mat-label>PAN</mat-label>
          <input matInput placeholder="Enter organsiation PAN" formControlName="pan_number">
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <small class="text-center w-full text-gray-500 mx-auto mt-[-10px] mb-[10px] text-italic">
          Not providing your PAN and GSTIN may affect your future benefits.
        </small>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select placeholder="Select your country" formControlName="country_id"
                      (selectionChange)="getStates()" required>
            <mat-option [value]="defaultCountry?.id">{{ defaultCountry?.name }}</mat-option>
            <mat-option *ngFor="let country of countries" [value]="country?.id">{{ country?.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4"
                        *ngIf="checkoutForm.value?.country_id.toString() === defaultCountry.id" appearance="outline">
          <mat-label>State</mat-label>
          <mat-select placeholder="Select organisation state" formControlName="state_id" required>
            <mat-option *ngFor="let state of states" [value]="state?.id">{{ state?.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4"
                        *ngIf="checkoutForm.value?.country_id.toString()  !== defaultCountry.id" appearance="outline">
          <mat-label>State</mat-label>
          <input matInput placeholder="Enter organisation state" formControlName="foreign_state_name">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('foreign_state_name').hasError('required')">State
            field is required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="flex-auto" appearance="outline" [style.font-family]="'var(--vex-font)'">
          <mat-label>Address</mat-label>
          <input matInput placeholder="Enter organisation address" formControlName="address">
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('address').hasError('required')">Address
            field is
            required</small>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row sm:gap-4 justify-between">
        <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline">
          <mat-label>City</mat-label>
          <input matInput placeholder="Enter organisation city" formControlName="city" required>
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('city').hasError('required')">City field is
            required</small>
        </mat-form-field>
        <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline">
          <mat-label>Zip Code</mat-label>
          <input matInput placeholder="Enter organisation zip code" formControlName="zip_code" required numbersOnly>
          <small class="text-danger text-italic"
                 *ngIf="pageExtras['submitted'] && checkoutForm.get('zip_code').hasError('required')">Zip code field
            is required</small>
        </mat-form-field>

      </div>
      <div class="text-center">
        <button class="bg-blue p-3 w-full md:w-1/4 text-white rounded-lg py-2 highlight-button"
                [style.font-family]="'var(--vex-font)'" (click)="updateBillingInformation()"><i
          class="fa-solid fa-check-circle"></i> Update
        </button>
      </div>
    </form>
  </div>
</ng-template>

<div class="container-fluid  border-b" [style.font-family]="'var(--vex-font)'">
  <div class="container px-8 py-14 mx-auto md:max-w-[80%]">
    <div class="grid md:grid-cols-3 gap-4">
      <div class="col-span-2">
        <div class="bg-white rounded-lg shadow-lg">
          <div class="p-6 text-center sm:text-start rounded-t-lg shadow-b bg-primary">
            <h2 class="text-xl font-semibold color-white">
              <i class="fa-solid fa-user-large me-2"></i>Login
            </h2>
          </div>
          <div class="p-6 bg-primary-600/10">
            <div
              class="card flex justify-between p-2 flex-col sm:flex-row mb-3 sm:text-center md:text-left lg:text-left xl:text-left shadow-none bg-transparent">
              <div class="py-2 md:min-w-[8%] md:max-w-[8%] text-center my-auto">
                <img [src]="user?.profile_image" class="w-[50px] md:w-full   mx-auto rounded-full" alt="">
              </div>
              <div class="py-2 md:min-w-[30%] md:max-w-[30%] text-center md:text-start md:ps-3 my-auto">
                <h5 class="text-bold f-16px">{{user?.organisation_name}}</h5>
                <small class="color-grey">Organisation Name</small>
              </div>
              <div class="py-2 md:min-w-[30%] md:max-w-[30%] text-center my-auto">
                <h5 class="text-bold f-16px">{{user?.name}} ({{user?.username}})</h5>
                <small class="color-grey">Buyer</small>
              </div>
              <div class="py-2 md:min-w-[30%] md:max-w-[30%] text-center my-auto">
                <h5 class="text-bold f-16px">{{user?.contact}}</h5>
                <small class="color-grey">Contact No.</small>
              </div>

            </div>
          </div>
          <div class="bg-white rounded-lg  shadow-lg">
            <div class="p-6 bg-primary text-center sm:text-start rounded-t-lg shadow-b">
              <h2 class="text-xl font-semibold color-white">
                <i class="fa-solid fa-award me-2"></i>Plan Details
              </h2>
            </div>
            <div class="p-6 bg-primary-600/10">
              <div
                class="card flex justify-between p-2 flex-col sm:flex-row mb-3 sm:text-center md:text-left lg:text-left xl:text-left shadow-none bg-transparent">
                <div class="py-2 md:min-w-[20%] md:max-w-[20%] text-center my-auto">
                  <h5 class="f-16px">{{planDetail?.name}}</h5>
                  <small class="color-grey">Name</small>
                </div>
                <div class="py-2 md:min-w-[20%] md:max-w-[20%] text-center my-auto">
                  <h5 class="f-16px">{{planDetail?.users}}</h5>
                  <small class="color-grey">Users</small>
                </div>
                <div class="py-2 md:min-w-[20%] md:max-w-[20%] text-center my-auto">
                  <h5 class="f-16px">{{planDetail?.overview}}</h5>
                  <small class="color-grey">Duration</small>
                </div>
                <div class="py-2 md:min-w-[20%] md:max-w-[20%] text-center my-auto">
                  <h5 class="f-16px">{{planDetail?.start_date}}</h5>
                  <small class="color-grey">Purchased date</small>
                </div>
                <div class="py-2 md:min-w-[20%] md:max-w-[20%] text-center my-auto">
                  <h5 class="f-16px">{{planDetail?.expiry_date}}</h5>
                  <small class="color-grey">Expiry date</small>
                </div>

              </div>
            </div>
            <div class="bg-white rounded-lg shadow-lg">
              <div
                class="bg-primary px-6 py-6 bg-gray-200 rounded-t-lg shadow-b flex flex-wrap items-center justify-between">
                <h2 class="text-xl font-semibold color-white">
                  <i class="fa-solid fa-file-invoice me-2"></i>Billing Information
                </h2>
                <i class="fa fa-edit cursor-pointer text-xl color-white" (click)="openUpdateBillingInformationModal()"></i>
              </div>
              <div class="p-6 bg-primary-600/10">
                <div class="card flex flex-wrap justify-between p-2 flex-col sm:flex-row mb-3 sm:text-center md:text-left lg:text-left xl:text-left shadow-none bg-transparent">
                  <div class="py-2 md:min-w-[50%] md:max-w-[50%] text-center my-auto">
                    <h4 class="f-16px">{{user?.address}}</h4>
                    <small class="color-grey">Address</small>
                  </div>
                  <div class="py-2 md:min-w-[50%] md:max-w-[50%] text-center my-auto">
                    <h4 class="f-16px">{{user?.city}}</h4>
                    <small class="color-grey">City</small>
                  </div>
                  <div class="py-2 md:min-w-[33.33%] md:max-w-[33.33%] text-center my-auto">
                    <h4 class="f-16px">{{user?.country_name}}</h4>
                    <small class="color-grey">Country</small>
                  </div>
                  <div class="py-2 md:min-w-[33.33%] md:max-w-[33.33%] text-center my-auto">
                    <h4 class="f-16px">{{user?.state_name}}</h4>
                    <small class="color-grey">State</small>
                  </div>
                  <div class="py-2 md:min-w-[33.33%] md:max-w-[33.33%] text-center my-auto">
                    <h4 class="f-16px">{{user?.zip_code}}</h4>
                    <small class="color-grey">Zip code</small>
                  </div>
                  <div class="py-2 md:min-w-[50%] md:max-w-[50%] text-center  my-auto">
                    <h4 class="f-16px" *ngIf="user && user['gst_number']">{{user?.gst_number}}</h4>
                    <h4 class="f-16px" *ngIf="!user || !user['gst_number']">-</h4>
                    <small class="color-grey">GSTIN</small>
                  </div>
                  <div class="py-2 md:min-w-[50%] md:max-w-[50%] text-center my-auto">
                    <h4 class="f-16px" *ngIf="user && user['pan_number']">{{user?.pan_number}}</h4>
                    <h4 class="f-16px" *ngIf="!user || !user['pan_number']">-</h4>
                    <small class="color-grey">PAN</small>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>

      <div class="col-span-2 md:col-span-1 ">
        <div class="h-full w-full p-18">
          <div class="bg-white md:h-[auto] rounded-lg shadow-lg ">
            <div
              class="px-6 py-6 bg-gray-200 rounded-t-lg shadow-b flex flex-wrap justify-center items-center sm:justify-between">
              <h2 class="text-xl font-semibold">
                <i class="fa-solid fa-money-check primary-icon me-2"></i>Price Details
              </h2>
            </div>
            <div class="bg-primary-600/10">
              <div class="p-5">
                <div class="flex justify-between">
                  <span class="text-gray-600 f-18px">Actual Price :</span>
                  <span class="f-18px text-bold">&#8377;{{planDetail?.price | IndianNumber}}/-</span>
                </div>
                <div class="flex justify-between my-2">
                  <span class="text-gray-600 f-18px">Discounted price : </span>
                  <span class="f-18px text-bold">&#8377;{{planDetail?.discounted_price | IndianNumber}}/-</span>
                </div>
                <div class="flex justify-between">
                  <span class="text-gray-600 f-18px">GST : </span>
                  <span class="f-18px text-bold">&#8377;{{planDetail?.gst | IndianNumber}}/-</span>
                </div>
                <div class="flex justify-between" *ngIf="planDetail && planDetail['active_coupon']">
                  <span class="text-gray-600 f-18px">Coupon code : </span>
                  <span class="f-18px text-bold text-success">
                    {{planDetail?.active_coupon?.coupon_code}}
                  </span>
                </div>
              </div>
              <div class=" border flex items-center justify-between py-4 border-s-0 border-e-0 px-4">
                <span>
                   <p class="text-gray-600 text-[20px] xl:text-[30px]">
                     <strong>Payable Amount </strong>
                   </p>
                </span>
                <span class="text-xl font-bold text-gray-600">
                   &#8377;{{Number(planDetail?.discounted_price) + Number(planDetail?.gst) | IndianNumber}}/-
                </span>
              </div>
              <div class="text-center ">
                <button class="search-btn w-1/3 my-4 mx-auto font-bold text-white rounded cursor-pointer" (click)="paymentInitiated(planDetail?.id)">
                  Pay Now
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <app-footer></app-footer>
